export function customEnv() {
  const { hostname } = window.location;

  let envPath = '';
  if (hostname.indexOf('localhost') > -1) {
    envPath = '-dev';
  } else if (hostname.indexOf('dsp.') > -1) {
    envPath = '-dev';
  } else if (hostname.indexOf('hmp.') > -1) {
    envPath = '-qa';
  }

  return {
    REACT_APP_ASSETS: `https://assets${envPath}.vr.com.br/app-mobile-ec`,
    REACT_APP_ASSETS_PORTAL: `https://assets${envPath}.vr.com.br/portalrh`,
  };
}

export const env = { ...process.env, ...customEnv() };
